import { createAsyncThunk } from "@reduxjs/toolkit";

//Include Both Helper File with needed methods
// import {
//   getEvents as getEventsApi,
//   addNewEvent as addNewEventApi,
//   updateEvent as updateEventApi,
//   deleteEvent as deleteEventApi,
//   getCategories as getCategoriesApi,
//   getUpCommingEvent as getUpCommingEventApi
// } from "../../helpers/fakebackend_helper";


import { 
    getEvents  as getEventsApi,
    addNewEvent as addNewEventApi,
    updateEvent as updateEventApi,
    deleteEvent as deleteEventApi, 
    getCategories as getCategoriesApi,
    getUpCommingEvent as getUpCommingEventApi,
    getOEMList as getOEMListApi,
    getEventById as getEventByIdApi
  } from '../../utils/calender';

export const getEvents = createAsyncThunk("calendar/getEvents", async () => {
  try {
    console.log('Fetching events from API...');
    const response = await getEventsApi(); 
    console.log('API response:', response);
    if (response && response.data) {
      console.log('Returning events data:', response.data);
      
      // Extract the actual events array from the response
      const eventsArray = response.data.data || response.data;
      
      // Transform events to FullCalendar format if needed
      const transformedEvents = Array.isArray(eventsArray) ? eventsArray.map(event => {
        console.log('Processing event:', event.id, 'with images:', event.images);
        return {
          id: event.id,
          title: event.title || event.name || 'Untitled Event',
          start: event.start || event.start_date || event.date,
          end: event.end || event.end_date || event.date,
          allDay: event.allDay || false,
          color: event.color || '#3788d8',
          ...event
        };
      }) : eventsArray;
      console.log('Transformed events:', transformedEvents);
      return transformedEvents;
    } else {
      console.log('No response data, returning empty array');
      return [];
    }
  } catch (error) {
    console.error('Error fetching events:', error);
    return [];
  }
});

export const addNewEvent = createAsyncThunk("calendar/addNewEvent", async (event) => {
  try { 
    console.log('addNewEvent thunk called with:', event);
    const response = await addNewEventApi(event); 
    console.log('addNewEvent API response:', response);
    if (response && response.data) {
      return response;
    } else {
      return { status: 400, message: "Failed to add event" };
    }
  } catch (error) {
    console.error('Error adding new event:', error);
    return { status: 500, message: "Error adding event" };
  }
});

export const updateEvent = createAsyncThunk("calendar/updateEvent", async (event) => {
  try {
    console.log('updateEvent thunk called with:', event);
    const response = await updateEventApi(event); 
    console.log('updateEvent API response:', response);
    if (response && response.data) {
      return response;
    } else {
      return { status: 400, message: "Failed to update event" };
    }
  } catch (error) {
    console.error('Error updating event:', error);
    return { status: 500, message: "Error updating event" };
  }
});

export const deleteEvent = createAsyncThunk("calendar/deleteEvent", async (event) => {
  try {
    const response = await deleteEventApi(event);
    if (response && response.data) {
      return response.data;
    } else {
      return event; // Return the event ID for deletion
    }
  } catch (error) {
    console.error('Error deleting event:', error);
    return event; // Return the event ID for deletion
  }
});

export const getCategories = createAsyncThunk("calendar/getCategories", async () => {
  try{
    const response = await getCategoriesApi();
    if (response && response.data) {
      return response.data;
    } else {
      return [];
    }
  }catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
})

export const getUpCommingEvent = createAsyncThunk("calendar/getUpCommingEvent", async () => {
  try{
    const response = await getUpCommingEventApi();
    if (response && response.data) {
      return response.data;
    } else {
      return [];
    }
  }catch (error) {
    console.error('Error fetching upcoming events:', error);
    return [];
  }
})
 
  export const fetchOEMList = createAsyncThunk("calendar/getOEMList", async (data) => {
    try{
      const response = await getOEMListApi(data);
      if (response && response.data && response.data.data) {
        return response.data.data;
      } else if (response && response.data) {
        return response.data;
      } else {
        return [];
      }
    }catch (error) {
      console.error('Error fetching OEM list:', error);
      return [];
    }
  })
   
export const resetCalendar = createAsyncThunk("calendar/resetCalendar", async () => {
  try{
    const response = '';
    return response;
  }catch (error) {
    return error;
  }
})

export const getEventById = createAsyncThunk("calendar/getEventById", async (id) => {
  try{
    const response = await getEventByIdApi(id);
    if (response && response.data && response.data.data) {
      return response.data.data;
    } else if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  }catch (error) {
    console.error('Error fetching event by ID:', error);
    return null;
  }
})